import { render } from "./PublicationCollaborators.vue.js?vue&type=template&id=44e1792a!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaborators.vue?vue&type=template&id=44e1792a"
import script from "./PublicationCollaborators.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaborators.vue?vue&type=script&lang=js"
export * from "./PublicationCollaborators.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaborators.vue?vue&type=script&lang=js"

import "./PublicationCollaborators.vue.scss?vue&type=style&index=0&id=44e1792a&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaborators.vue?vue&type=style&index=0&id=44e1792a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationCollaborators.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44e1792a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44e1792a', __exports__)) {
    api.reload('44e1792a', __exports__)
  }
  
  module.hot.accept("./PublicationCollaborators.vue.js?vue&type=template&id=44e1792a!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaborators.vue?vue&type=template&id=44e1792a", () => {
    api.rerender('44e1792a', render)
  })

}


export default __exports__